var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('a',{staticClass:"ck-logout-link",attrs:{"href":"#","title":"Logout"},on:{"click":_vm.logoutUser}},[_c('i',{staticClass:"fa fa-power-off"}),_c('span',{staticClass:"is-sr"},[_vm._v("Logout")])])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-148e167e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ckLogoutLink.vue
// module id = Vey+
// module chunks = 0